// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"373":"e5c7d630","420":"703fc86a"}[chunkId] + ".chunk.css";
};